module.exports = __webpack_public_path__ + "88cf22e8ccf8054429df9910c3306521.png";